import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
//import LibraryHeader from './LibraryHeader';
//import { latestArrivalList } from '../../ProData';
//import NewFaceView from '../NewFaceView';
import {Helmet} from "react-helmet-async";
import axios from 'axios';
import bookImage from '../../assets/images/cat1.png';
//import defaultAvatar from '../../assets/photos/defaultAvatar.jpg';
import './LatestArrivalsView.css';
import Preloader from '../../components/Preloader/Preloader';
const config = require('../../config.json');


function LatestArrivalsView() {
    const [insights, setInsights] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [modalItem, setModalItem] = useState(null);
    // accept optional initial data
    useEffect(()=>{ if(window && window.__LATEST_ARRIVALS__) setInsights(window.__LATEST_ARRIVALS__); }, []);
    //const [imgsrc, setImgsrc] = useState();

    const openModal = (item) => setModalItem(item);
    const closeModal = () => setModalItem(null);

    useEffect(()=> {
      const onKey = (e) => { if (e.key === 'Escape') setModalItem(null); };
      window.addEventListener('keydown', onKey);
      return () => window.removeEventListener('keydown', onKey);
    }, []);

    const isNewArrival = (dateStr) => {
      if(!dateStr) return false;
      const diff = Date.now() - new Date(dateStr).getTime();
      return diff < 30 * 24 * 60 * 60 * 1000; // 30 days
    }

    useEffect(() => {
        fetchActiveInfo();
    }, [])

    const generateDate = async () => {
        const d = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
    } 

    const fetchActiveInfo =async()=>{
        try{
           setLoaded(false);
            const startDate=await generateDate();
            const clientID="VJCollege";
            const searchOption="Latest Arrivals";
        const response = await axios.get(`${config.libraryapi.invokeURL}/vjlibrary/latestarrivals`, {
            params: { clientID, startDate, searchOption },
            headers: { 'x-api-key': config.libraryapi.key }
        });
        const data = response.data || [];
        //console.log("Latest Arrivals Data:", data);
        if (data.length > 0) {
            let test = data.slice();
            //console.log("Latest Arrivals before sort:", test);
            // Remove trailing placeholder if present
            test = test.slice(0, test.length-1);
           // if (test.length === 50) test = test.slice(0, -1);
            // Robust sort by registeredOn, handling missing/invalid dates
            const result = test.sort((a, b) => {
                const dateA = new Date(a.registeredOn);
                const dateB = new Date(b.registeredOn);
                if (isNaN(dateA)) return 1;
                if (isNaN(dateB)) return -1;
                return dateA - dateB;
            }).reverse();
            setInsights(result);
        }
        setLoaded(true);
    }catch(error){
        setLoaded(true);
            console.log("Error :", error.message);
    }
    }

    const handleImageError = (event) => {
        event.target.src = bookImage;
      };
  

  return (
    <>
    <Helmet>
      <title>Library - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies</title>
      <meta name="description" content="Library - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies" />
      <meta name="keywords" content="Library - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies" />
      <link rel="canonical" href="/library/latest" />
    </Helmet>
    <Preloader show={loaded ? false : true} />

       {/*} <LibraryHeader />
        <NewFaceView />*/}
        <div className="container-fluid blog py-5 mb-5">
            <div className="container">
                <div className="text-center mx-auto pb-4 wow fadeIn" data-wow-delay=".3s" style={{maxWidth: "680px"}}>
                    <h5 className="text-primary mb-2">Our Library</h5>
                    <h1 className="display-5 fw-semibold">Latest Arrivals <span className="text-muted">({insights.length})</span></h1>
                    <p className="lead text-muted mt-2">Discover recently added books and resources to the Vidyajyoti library collection.</p>
                </div>
                <div className="row g-5 justify-content-center latest-arrivals-grid">
                {loaded && insights.length>0 && insights.map((item) => {
                    const poster = `${config.s3.bookPoster}${item.accessionNo}.jpeg`;
                    const newFlag = isNewArrival(item.registeredOn);
                    return (
                      <div key={item.accessionNo} className="col-sm-6 col-md-4 col-lg-3 col-xl-3 wow fadeIn" data-wow-delay=".3s">
                        <div className="arrival-card bg-white rounded overflow-hidden h-100 shadow-sm">
                          <div
                            className="arrival-thumb"
                            role="button"
                            tabIndex="0"
                            onClick={() => openModal(item)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openModal(item); }}
                            aria-label={`View details for ${item.bookTitle}`}
                          >
                            <img src={poster} loading="lazy" className="card-img" alt={`${item.bookTitle} cover`} onError={handleImageError} />
                            {newFlag && <span className="badge-new">New</span>}
                          </div>
                          <div className="card-body text-center p-3 d-flex flex-column">
                            <h6 className="title mb-1" title={item.bookTitle}>{item.bookTitle}</h6>
                            <small className="author text-muted">{item.bookAuthor}</small>
                          </div>
                          <div className="card-footer text-center py-2 px-3 border-top">
                            <small className="text-muted">Acc#: {item.accessionNo}</small>
                          </div>
                        </div>
                      </div>
                    )
                })}
                </div>
            </div>
        </div>

        {modalItem && (
          <div className="modal-overlay" onClick={(e)=> { if (e.target.classList.contains('modal-overlay')) closeModal(); }}>
            <div className="modal-content" role="dialog" aria-modal="true" aria-label={`Details for ${modalItem.bookTitle}`}>
              <button className="modal-close" onClick={closeModal} aria-label="Close">×</button>
              <div className="modal-body d-flex align-items-start">
                <img src={`${config.s3.bookPoster}${modalItem.accessionNo}.jpeg`} onError={handleImageError} alt={`${modalItem.bookTitle} cover`} className="modal-img"/>
                <div className="modal-info ms-3">
                  <h3 className="mb-1">{modalItem.bookTitle}</h3>
                  <p className="author mb-2 text-muted">{modalItem.bookAuthor}</p>
                  <p className="meta text-muted">Acc#: {modalItem.accessionNo} • {modalItem.registeredOn ? new Date(modalItem.registeredOn).toLocaleDateString() : ''}</p>
                  {modalItem.bookDescription && <p className="mt-2">{modalItem.bookDescription}</p>}
                  <div className="mt-3">
                    <button className="btn btn-primary btn-sm" onClick={closeModal}>Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

    </>
    ) // end return
}

LatestArrivalsView.propTypes = {
  // optional initial data for testing
  initialData: PropTypes.array
};

export default LatestArrivalsView;
